import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_CORGI_OAUTH_MIGRATION_CONFIG = defineFcm('corgi_oauth_migration_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: {
					type: 'boolean',
				},
				mode: {
					type: 'enum',
					values: ['read', 'read-write'],
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		mode: 'read-write',
	})
	.toConfig();
